function createEaseOut(easeIn) {
  return (progress) => 1 - easeIn(1 - progress);
}
function createEaseInOut(easeIn) {
  return (progress) => progress === 0 ? 0 : progress === 1 ? 1 : progress < 0.5 ? easeIn(progress * 2) / 2 : 1 - easeIn((1 - progress) * 2) / 2;
}
export {
  createEaseInOut,
  createEaseOut
};
//# sourceMappingURL=createEases.js.map
